import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

// Self-hosted fonts (replaces Google Fonts preload). Loaded via @fontsource
// so the @font-face declarations are bundled by Vite and served from the
// same origin — no third-party requests, no ePrivacy / Munich-ruling exposure.
import '@fontsource/ubuntu/400.css'
import '@fontsource/ubuntu/500.css'
import '@fontsource/ubuntu/700.css'
import '@fontsource/jetbrains-mono/400.css'
import '@fontsource/jetbrains-mono/500.css'

import './global.css'
import { LandingPage } from './pages/LandingPage'
import { LanguagePage } from './pages/LanguagePage'
import { ToolsPage } from './pages/ToolsPage'
import { ShowcasePage } from './pages/ShowcasePage'
import { PrivacyPage } from './pages/PrivacyPage'
import { TermsPage } from './pages/TermsPage'
import { LegalPage } from './pages/LegalPage'

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/language" element={<LanguagePage />} />
                <Route path="/examples" element={<ToolsPage />} />
                <Route path="/showcase" element={<ShowcasePage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/legal" element={<LegalPage />} />
            </Routes>
        </BrowserRouter>
    </StrictMode>,
)
